const c = {
  name: "Queue",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M36,0c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4C40,1.8,38.2,0,36,0z M34,4c0-1.1,0.9-2,2-2
			c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2C34.9,6,34,5.1,34,4z"/>
		<path class="st0" d="M35,10c-1.7,0-3,1.3-3,3v27h2V13c0-0.5,0.5-1,1-1h2c0.5,0,1,0.5,1,1v27h2V13c0-1.7-1.3-3-3-3H35z"/>
		<path class="st0" d="M21.3,10c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4c0,2.2-1.8,4-4,4C23.1,14,21.3,12.2,21.3,10z M25.3,8
			c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2C27.3,8.9,26.4,8,25.3,8z"/>
		<path class="st0" d="M24.3,16c-1.7,0-3,1.3-3,3v21h2V19c0-0.5,0.5-1,1-1h2c0.5,0,1,0.5,1,1v21h2V19c0-1.7-1.3-3-3-3H24.3z"/>
		<path class="st0" d="M10.7,18c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4s-1.8,4-4,4C12.5,22,10.7,20.2,10.7,18z M14.7,16c-1.1,0-2,0.9-2,2
			c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2C16.7,16.9,15.8,16,14.7,16z"/>
		<path class="st0" d="M13.7,24c-1.7,0-3,1.3-3,3v13h2V27c0-0.5,0.5-1,1-1h2c0.5,0,1,0.5,1,1v13h2V27c0-1.7-1.3-3-3-3H13.7z"/>
		<path class="st0" d="M0,13c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4S0,15.2,0,13z M4,11c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2
			S5.1,11,4,11z"/>
		<path class="st0" d="M3,19c-1.7,0-3,1.3-3,3v18h2V22c0-0.5,0.5-1,1-1h2c0.5,0,1,0.5,1,1v18h2V22c0-1.7-1.3-3-3-3H3z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Queue
};
